import { Box, Grid2, Button, Dialog, Typography } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { ToastError } from "../../utils/Toaster/Toaster";
import React, { useEffect, useState } from "react";
import { deleteShift, getAllShift } from "../../services/shifts.service";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import AddShift from "./AddShift";
import dayjs from "dayjs";

const Shifts = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const res = await getAllShift();
      if (res?.data) {
        const formattedData = res?.data?.map((item) => ({
          ...item,
          expectedInTime: dayjs(item.expectedInTime).format("hh:mm A"),
          expectedOutTime: dayjs(item.expectedOutTime).format("hh:mm A"),
        }));
        setData(formattedData);
      }
    } catch (error) {
      console.log("err", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteShift(e._id);
      ToastError(res.message);
      await fetchData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const columns = [
    { id: "shiftName", label: "Name" },
    { id: "expectedInTime", label: "Expected In Time" },
    { id: "expectedOutTime", label: "Expected Out Time" },
  ];

  const tableConfig = {
    isMore: true,
    isAdmin: true,
    isAction: true,
    isEdit: canEdit("shifts"),
    isView: true,
    isDelete: canDelete("shifts"),
  };
  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid2 container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid2 item xs={12} sm={6.5} />
          <Grid2 item xs={12} sm={1.7}>
            <PermissionGate module="shifts" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAdd()}
                className="Add-Button"
              >
                Add Shift
              </Button>
            </PermissionGate>
          </Grid2>
        </Grid2>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleEdit={handleEdit}
        handleView={handleView}
        handleDelete={handleDelete}
      />

      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <AddShift
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={fetchData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default Shifts;
